import { Injectable, Inject } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { ConfigurationActions } from '@actions/index';
import { PolicyActions } from '@actions/configuration/index';
import { OracleStorageService } from '@services/oracle-storage.service';
import { PolicyModel } from '@models/configuration/policy.model';


@Injectable()
export class PolicyEffects {
    // Policys Effects
    searchPolicys$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PolicyActions.searchPolicies),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .search$(action)
                    .pipe(
                        tap(x=>console.log(x)),
                        map((policies: any) => {
                            let array = policies.data;
                            return array.map((item: any) => {
                                let newItem = {
                                    id: item.policyId,
                                    idCustomer: item.customers,
                                    name: item.name,
                                    nameCustomer: item.customers,
                                    policyCode: item.policyId,
                                    valididationPeriod: item.validityPeriod
                                }
                                return newItem;
                            });
                        }),
                        tap(x=>console.log(x)),
                        map((Policies: PolicyModel[]) => PolicyActions
                            .searchPoliciesSuccess({ Policies })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),PolicyActions.resetLoading()))
                    )
            ))
    );

    createPolicys$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PolicyActions.createPolicy),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .create$(action)
                    .pipe(
                        map((Policy: PolicyModel) => PolicyActions
                            .createPolicySuccess({ Policy })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),PolicyActions.resetLoading()))
                    )
            ))
    );

    updatePolicys$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PolicyActions.updatePolicy),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .update$(action)
                    .pipe(
                        map((Policy: PolicyModel) => PolicyActions
                            .updatePolicySuccess({ Policy })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),PolicyActions.resetLoading()))
                    )
            ))
    );

    deletePolicys$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PolicyActions.deletePolicy),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .delete$(action)
                    .pipe(
                        map((Policy: PolicyModel) => PolicyActions
                            .deletePolicySuccess({ Policy })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),PolicyActions.resetLoading()))
                    )
            ))
    );
    
    constructor(
        private actions$: Actions,
        @Inject('OracleStorageService') private oracleStorageService: OracleStorageService<PolicyModel>,
    ) { }
}